import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';

export const getFeedKey = () => ['feed'] as const;

type RegularFeedListQuery = GenericListQueryKey<{ communityId?: string; pinned?: boolean }>;

export const getRegularFeedListQueryKey = (params: RegularFeedListQuery) =>
  generateListQueryKey({
    prefix: [...getFeedKey(), 'regular'],
  })(params);

export const getRegularFeedInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getRegularFeedListQueryKey,
});

type JournalFeedListQuery = GenericListQueryKey;

export const getJournalFeedListQueryKey = (params: JournalFeedListQuery) =>
  generateListQueryKey({
    prefix: [...getFeedKey(), 'journal'],
  })(params);

export const getJournalFeedInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getJournalFeedListQueryKey,
});

type PinnedFeedListQuery = GenericListQueryKey<{ communityId?: string }>;

export const getPinnedFeedListQueryKey = (params: PinnedFeedListQuery) =>
  generateListQueryKey({
    prefix: [...getFeedKey(), 'pinned'],
  })(params);

export const getPinnedFeedInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getPinnedFeedListQueryKey,
});

type ProgramFeedListQuery = GenericListQueryKey<{ feedKey?: string }>;

export const getProgramFeedListQueryKey = (params: ProgramFeedListQuery) =>
  generateListQueryKey({
    prefix: [...getFeedKey(), 'program'],
  })(params);

export const getProgramFeedInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getProgramFeedListQueryKey,
});

// Matches the feedKey used by features/programs/program-timeline, the only current reader of the program feed cache.
export const getProgramFeedKey = ({ programId, programTopicId }: { programId: string; programTopicId: string }) =>
  `program-${programId}-topic-${programTopicId}`;

type BookmarksFeedListQuery = GenericListQueryKey;

export const getBookmarksFeedListQueryKey = (params: BookmarksFeedListQuery) =>
  generateListQueryKey({
    prefix: [...getFeedKey(), 'bookmarks'],
  })(params);

export const getBookmarksFeedInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getBookmarksFeedListQueryKey,
});
